// extracted by mini-css-extract-plugin
export default {"full":"buttonWidth_full__n0wTn","fullSm":"buttonWidth_fullSm__SoTqd","fullMd":"buttonWidth_fullMd__Ksb69"};